import { useState } from 'react';
import { gql, useLazyQuery, useSubscription, useMutation } from "@apollo/client";
import { Box, Autocomplete, TextField, Button, CircularProgress } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux';
import { selectUser } from "../../features/auth/authSlice";
import { showErrorSnackbar, showSuccessSnackbar } from '../../features/snackbar/snackbarSlice';
import { useAppDispatch } from '../../app/hooks';
import { FlexEnd } from '../../commonStyles';

const CopyRegistrants = (props: ChildProps) => {
  const { id } = props;
  const storeDispatch = useAppDispatch();
  const user = useSelector(selectUser);
  const [project, setProject] = useState<any>(null);

  const [copyList, { loading }] = useMutation(COPYREGISTRANTS, {
    onCompleted: (data) => {
      storeDispatch(showSuccessSnackbar("List copied successfully"));
    },
    onError: (err) => {
      storeDispatch(showErrorSnackbar("Error updating Appointment"));
      console.log(err, "err");
    },
  });

  const handleCopy = () => {
    if (!project) {
      storeDispatch(showErrorSnackbar("Please select a project to copy list to"));
      return;
    }
    copyList({
      variables: {
        _id: id,
        project: project._id
      }
    })
  }

  return (
    <div>
      <Box sx={{ mb: 2 }}>Please select the project you would like to copy registrants to:</Box>
      <Autocomplete
        options={[user?.projectAccess!.map((projectAccess: any) => projectAccess?.project!)].flat()}
        freeSolo={false}
        value={project}
        isOptionEqualToValue={(option, value) => option === value}
        getOptionLabel={(option: any) => option.name}
        onChange={(e, value) => {
          setProject(value);
        }}
        renderInput={(params) => <TextField {...params} label="Projects" />}
      />
      <FlexEnd sx={{ mt: 2 }}>
        <Button variant="contained" onClick={() => handleCopy()} color="success" autoFocus>
          {!loading ? 'Copy' : <CircularProgress size={24} sx={{ color: "#fff"}} />}
        </Button>
      </FlexEnd>
    </div>
  )
}

interface ChildProps {
  id?: string;
}

const COPYREGISTRANTS = gql`
  mutation copyList($_id: MongoID!, $project: MongoID!) {
    copyList(_id: $_id, project: $project)
  }
`;

export default CopyRegistrants